import {defaultState, getters, mutations} from '@/plugins/store/defaultServiceState'
import axios from 'axios';
import store from "@/plugins/store";
// import VueJwtDecode from 'vue-jwt-decode'

export default {
    namespaced: true,
    state: {
        ...defaultState
    },
    getters: {
        ...getters
    },
    mutations: {
        ...mutations
    },
    actions: {
        addElement({commit, state}, element) {
            const elements = state.items.filter(i => i.kyc_name !== element.kyc_name);
            elements.push(element);
            commit("items", elements);
        },
        fetchKycDocuments({commit}) {

            const token = store.state.security.jwt;
            // let decodedJwt = VueJwtDecode.decode(token);
            // console.log('token', token);
            // console.log('decodedJwt', decodedJwt);
            commit('isLoading', true);
            axios({
                // this endpoint is incorrect, we need to call someone else to bring specific information
                url: `/api/v1/shareholders/kyc_info_by_token`, //your url
                method: 'GET',
                // responseType: 'blob', // important
                headers: {
                    "Authorization": `${token}`,
                }
            }).then((response) => {
                // console.log('response.data.data', response.data.data);
                commit('items', response.data.data.kyc_info);
                commit('isLoading', false);
                commit('error', null);
            }).catch((error) => {
                commit('isLoading', false);
                commit('error', error.response.data || error.message);
            });
        },
        save_kyc_documents({commit, dispatch}, payload) {
            const token = store.state.security.jwt;
            // let decodedJwt = VueJwtDecode.decode(token);
            // console.log('token', token);
            // console.log('decodedJwt', decodedJwt);
            commit('isSaving', true);
            axios({
                // this endpoint is incorrect, we need to call someone else to bring specific information
                url: `/api/v1/shareholders/kyc_documents`, //your url
                method: 'POST',
                data: payload,
                // responseType: 'blob', // important
                headers: {
                    "Authorization": `${token}`,
                }
            }).then((response) => {
                console.log('response.data.data', response.data.data);
                dispatch("addElement", response.data.data);
                // commit('items', response.data.data.kyc_info);
                commit('isSaving', false);
                commit('error', null);

            }).catch((error) => {
                commit('isSaving', false);
                commit('error', error.response.data || error.message);
            });

        }
    }
}